import { render } from "./SDALH.vue?vue&type=template&id=49b1dd3a"
import script from "./SDALH.vue?vue&type=script&lang=js"
export * from "./SDALH.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__